export interface TransactionDataInterface {
  id: number,
  activityDate: string;
  mpc: string;
  mpcDesc: string;
  creditingDate: string;
  points: string;
}

export const defaultTransactionData = {
  id: 0,
  activityDate: "",
  mpc: "",
  mpcDesc: "",
  creditingDate: "",
  points: "",
} as TransactionDataInterface;
